<template>
    <div>
        <h3>登录用户流失率分析</h3>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>次日流失率</span>

                <el-date-picker
                    v-model="periodDay"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    :picker-options="dayPickerOptions"
                    @change="handleChange('dayly', $event)"
                >
                </el-date-picker>
            </div>
            <div>
                <ve-bar-chart
                    :data="dayData"
                    :settings="chartSettings"
                    v-bind="options"
                    :loading="dayLoad"
                />
            </div>
        </el-card>

        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>次周流失率</span>

                <el-date-picker
                    v-model="periodWeek"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    :picker-options="weekPickerOptions"
                    @change="handleChange('weekly', $event)"
                >
                </el-date-picker>
            </div>
            <div>
                <ve-bar-chart
                    :data="weekData"
                    :settings="chartSettings"
                    v-bind="options"
                    :loading="weekLoad"
                />
            </div>
        </el-card>
    </div>
</template>

<script>
import Server from "../../../server";
export default {
    name: "login-churn-rate",
    data() {
        return {
            dayPickerOptions: {
                disabledDate: this.disabledDate,
                shortcuts: [
                    this.createShortcut("今天", 0),
                    this.createShortcut("昨天", 1),
                    this.createShortcut("最近7天", 7),
                    this.createShortcut("最近半月", 15),
                ],
            },
            weekPickerOptions: {
                disabledDate: this.disabledDate,
                shortcuts: [
                    this.createShortcut("最近一周", 7),
                    this.createShortcut("最近四周", 30),
                    this.createShortcut("最近十二周", 90),
                ],
            },
            chartSettings: {
                label: {
                    show: true,
                    fontSize: "12",
                    fontWeight: "bold",
                    formatter: (params) => {
                        // console.log("params--->", params);
                    },
                },
            },
            options: {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                    },
                    textStyle: {
                        color: "#fff",
                    },
                    formatter: function (params) {
                        // console.log("params--->", params, _this);

                        const dimensionNames = params[0].dimensionNames;
                        let subtractDays = 0;

                        if (dimensionNames && dimensionNames[0] === "weekly") {
                            subtractDays = 7;
                        } else if (
                            dimensionNames &&
                            dimensionNames[0] === "dayly"
                        ) {
                            subtractDays = 1;
                        }

                        const date = new Date(params[0].name);
                        date.setDate(date.getDate() - subtractDays);
                        const formattedDate = date.toLocaleDateString();

                        return (
                            "<span class='test' style='background: " +
                            params[0].color +
                            ";'></span>" +
                            formattedDate +
                            " 的流失率：" +
                            params[0].data[1] * 100 +
                            "%"
                        );
                    },
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        formatter: (value) => (value * 100).toFixed(2) + "%",
                    },
                    axisPointer: {
                        snap: true,
                    },
                },
            },
            dayLoad: true,
            weekLoad: true,
            periodDay: this.periodDate(5),
            periodWeek: this.periodDate(60),
            dayData: null,
            weekData: null,
        };
    },
    mounted() {
        this.initData(this.periodDay, "dayly");
        this.initData(this.periodWeek, "weekly");
    },
    methods: {
        periodDate(offsetInDays, format) {
            const end = new Date();
            const start = new Date();
            start.setDate(end.getDate() - offsetInDays);
            return [
                this.$Met.formatDate(start, format),
                this.$Met.formatDate(end, format),
            ];
        },
        disabledDate(time) {
            return time.getTime() > Date.now();
        },
        getStartAndEndDates(offsetInDays) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * offsetInDays);
            return [start, end];
        },
        createShortcut(text, offsetInDays) {
            return {
                text: text,
                onClick: (picker) => {
                    picker.$emit(
                        "pick",
                        this.getStartAndEndDates(offsetInDays)
                    );
                },
            };
        },
        async initData(period, time_dimension) {
            try {
                const params = {
                    start_date: period[0],
                    end_date: period[1],
                    time_dimension,
                };
                const { data } = await Server.get_login_rate(params);
                console.log("day data--->", data);
                if (data.code !== 0) throw new Error(data.error);
                let chartData = null;
                if (Object.keys(data.data).length > 0) {
                    chartData = this.processData(data.data, time_dimension);
                }
                this.updateChartData(time_dimension, chartData);
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: "error",
                });
            } finally {
                this.dayLoad = false;
                this.weekLoad = false;
            }
        },
        processData(data, time_dimension) {
            const times = [];
            const churns = [];
            let isFirstEntry = true;

            for (const date in data) {
                if (isFirstEntry) {
                    isFirstEntry = false;
                    continue;
                }
                const values = data[date];
                const lastUserTotal = values.last_user_total;
                const retain = values.retain;

                if (time_dimension === "weekly") {
                    const [year, week] = date.split("-").map(Number);
                    const startDate = this.$Met.startDateFromWeek(year, week);
                    times.push(startDate.toISOString().split("T")[0]);
                } else {
                    times.push(date);
                }

                if (lastUserTotal !== 0) {
                    const result = (
                        (lastUserTotal - retain) /
                        lastUserTotal
                    ).toFixed(lastUserTotal - retain === 0 ? 0 : 2);
                    churns.push(result);
                } else {
                    churns.push(0);
                }
            }

            console.log("times--->", data, times, churns);

            return {
                dimensions: {
                    name: time_dimension,
                    data: times,
                },
                measures: [
                    {
                        name: "登陆用户流失率",
                        data: churns,
                    },
                ],
            };
        },
        updateChartData(time_dimension, chartData) {
            const dataMapping = {
                dayly: "dayData",
                weekly: "weekData",
            };
            this[dataMapping[time_dimension]] = chartData;
        },
        handleChange(timeDimension, dateRange) {
            console.log("change--->", timeDimension, dateRange);
            const loadMapping = {
                dayly: "dayLoad",
                weekly: "weekLoad",
                monthly: "monthLoad",
            };
            this[loadMapping[timeDimension]] = true;
            this.initData(dateRange, timeDimension);
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.clearfix {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.box-card {
    margin-bottom: 70px;
}
</style>